<template>
  <div>
    <template
      v-for="(level1Item, itemIndex) in menu"
    >
      <FavoritesSection
        v-if="level1Item.key === 'menu.favorites'"
        :key="`favorites-${level1Item.key}`"
        :items="level1Item.items || []"
        :rail="rail"
        :open-flyout-key="openFlyoutKey"
        @update:flyout="updateOpenFlyout"
      />
      <template v-else>
        <!-- EXPANDED MODE: Home with toggle beside it -->
        <div
          v-if="isHomeItem(itemIndex) && !rail"
          :key="`home-with-toggle-${level1Item.key}`"
          class="home-toggle-wrapper"
        >
          <flowy-nav-menu-item
            :menu-item="level1Item"
            :rail="rail"
            :open-flyout-key="openFlyoutKey"
            :class="getItemClasses(itemIndex)"
            @update:flyout="updateOpenFlyout"
          />
          <v-btn
            icon
            variant="text"
            size="x-small"
            class="home-toggle-btn"
            @click.stop="$emit('toggle-rail')"
          >
            <v-icon size="small" class="custom-nav-color">
              {{ collapseIcon }}
            </v-icon>
          </v-btn>
        </div>

        <!-- Regular menu items (non-Home) -->
        <flowy-nav-menu-item
          v-else-if="!isHomeItem(itemIndex)"
          :key="`level1-${level1Item.text}-${level1Item.key}`"
          :menu-item="level1Item"
          :rail="rail"
          :open-flyout-key="openFlyoutKey"
          @update:flyout="updateOpenFlyout"
        />

        <!-- RAIL MODE: Home item -->
        <flowy-nav-menu-item
          v-if="isHomeItem(itemIndex) && rail"
          :key="`level1-rail-${level1Item.text}-${level1Item.key}`"
          :menu-item="level1Item"
          :rail="rail"
          :open-flyout-key="openFlyoutKey"
          @update:flyout="updateOpenFlyout"
        />
        <!-- RAIL MODE: Toggle button as standalone item after Home -->
        <v-list-item
          v-if="isHomeItem(itemIndex) && rail"
          :key="`toggle-${itemIndex}`"
          @click.stop="$emit('toggle-rail')"
        >
          <template #prepend>
            <v-icon class="custom-nav-color">
              {{ expandIcon }}
            </v-icon>
          </template>
        </v-list-item>
      </template>
    </template>
  </div>
</template>

<script>
import FlowyNavMenuItem from './FlowyNavMenuItem'
import FavoritesSection from './FavoritesSection.vue'
import { mapGetters } from 'vuex'

/*
|---------------------------------------------------------------------
| Navigation Menu Component
|---------------------------------------------------------------------
|
| Multi-layer navigation menu
|
| menu: [{ text: 'Menu Levels',
|    items: [
|      { text: 'Menu Levels 2.1' },
|      { text: 'Menu Levels 2.2',
|        items: [
|          { text: 'Menu Levels 3.1' },
|          { text: 'Menu Levels 3.2' }
|        ]
|      }
|    ]
|  }]
|
*/
export default {
  components: {
    FlowyNavMenuItem,
    FavoritesSection
  },
  props: {
    index: {
      type: Number,
      default: 0
    },
    rail: {
      type: Boolean
    },
    menu: {
      type: Array,
      default: () => []
    }
  },
  emits: ['toggle-rail'],
  data() {
    return {
      openFlyoutKey: null
    }
  },
  computed: {
    ...mapGetters('app', ['isRTL']),
    // Collapse icon for expanded mode (chevron pointing towards drawer edge)
    collapseIcon() {
      return this.isRTL ? 'mdi-chevron-right' : 'mdi-chevron-left'
    },
    // Expand icon for rail mode (chevron pointing away from drawer)
    expandIcon() {
      return this.isRTL ? 'mdi-chevron-left' : 'mdi-chevron-right'
    }
  },
  methods: {
    isHomeItem(itemIndex) {
      // Home is the first item in the first section (index === 0)
      return this.index === 0 && itemIndex === 0
    },
    getItemClasses(itemIndex) {
      const isFirstItemInFirstSection = this.index === 0 && itemIndex === 0 && !this.rail
      return {
        'pe-6': isFirstItemInFirstSection && !this.isRTL,
        'ps-6': isFirstItemInFirstSection && this.isRTL
      }
    },
    updateOpenFlyout(menuKey, isOpen) {
      this.openFlyoutKey = isOpen ? menuKey : null
    }
  }
}
</script>

<style lang="scss" scoped>
.home-toggle-wrapper {
  position: relative;

  .home-toggle-btn {
    position: absolute;
    top: 50%;
    // Use logical property for RTL support: right in LTR, left in RTL
    inset-inline-end: 4px;
    transform: translateY(-50%);
    opacity: 0.7;

    &:hover {
      opacity: 1;
    }
  }
}
</style>
